(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brands-listing"] && !Shopify.designMode) return;
  try {
    
  class BrandsListing extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') {
        this.filters?.addEventListener('click', this.handleFilterClick);
        return;
      }

      this.dataset.initialized = 'true';
      this.results = this.querySelector('[data-brands-listing-results]');
      this.filters = this.querySelector('[data-brands-listing-filters]');
      this.pagination = this.querySelector('[data-brands-listing-pagination]');
      this.status = this.querySelector('[data-brands-listing-status]');
      this.errorMessage = this.querySelector('[data-brands-listing-error]');
      this.handleFilterClick = this.handleFilterClick.bind(this);

      this.loadAllBrands();
    }

    disconnectedCallback() {
      this.filters?.removeEventListener('click', this.handleFilterClick);
    }

    async loadAllBrands() {
      if (!this.results) return;

      const currentPage = Number.parseInt(this.dataset.currentPage || '1', 10);
      const totalPages = Number.parseInt(this.dataset.totalPages || '1', 10);
      const pageNumbers = Array.from({ length: totalPages }, (_, index) => index + 1).filter(
        (page) => page !== currentPage,
      );
      const initialItems = this.deduplicateItems([...this.querySelectorAll('[data-brand-item]')]);

      this.renderGroups(initialItems);
      if (this.status) this.status.textContent = `${initialItems.length} brands shown. Loading the complete brand list.`;

      try {
        const pageItems = await Promise.all(pageNumbers.map((page) => this.fetchPageItems(page)));
        const allItems = [...this.querySelectorAll('[data-brand-item]'), ...pageItems.flat()];
        const uniqueItems = this.deduplicateItems(allItems);

        this.renderGroups(uniqueItems);
        this.dataset.state = 'ready';
        this.results.setAttribute('aria-busy', 'false');
        if (this.pagination) this.pagination.hidden = true;
        if (this.status) this.status.textContent = `${uniqueItems.length} brands loaded.`;
      } catch (error) {
        this.dataset.state = 'fallback';
        this.results.setAttribute('aria-busy', 'false');
        if (this.errorMessage) this.errorMessage.hidden = false;
        if (this.status) this.status.textContent = 'The complete brand list could not be loaded.';
        console.error('[Brands listing] Unable to load every brand page.', error);
      }
    }

    async fetchPageItems(page) {
      const url = new URL(window.location.href);
      url.searchParams.set('section_id', this.dataset.sectionId);
      url.searchParams.set(this.dataset.pageParam || 'page', String(page));

      const response = await fetch(url, {
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
      });

      if (!response.ok) throw new Error(`Brand page ${page} request failed with ${response.status}`);

      const fragment = new DOMParser().parseFromString(await response.text(), 'text/html');
      const listing = fragment.querySelector('[data-brands-listing]');

      if (!listing) throw new Error(`Brand page ${page} was not returned`);

      return [...listing.querySelectorAll('[data-brand-item]')];
    }

    deduplicateItems(items) {
      const uniqueItems = new Map();
      const collator = new Intl.Collator(undefined, { numeric: true, sensitivity: 'base' });

      items.forEach((item) => {
        const key = item.dataset.brandHandle || `${item.dataset.brandName}-${item.querySelector('a')?.href}`;
        if (key && !uniqueItems.has(key)) uniqueItems.set(key, item);
      });

      return [...uniqueItems.values()].sort((left, right) =>
        collator.compare(left.dataset.brandName || '', right.dataset.brandName || ''),
      );
    }

    renderGroups(items) {
      const groups = new Map();

      items.forEach((item) => {
        const key = this.groupKey(item.dataset.brandName || '');
        if (!groups.has(key)) groups.set(key, []);
        groups.get(key).push(item);
      });

      const orderedKeys = ['0-9', ...'ABCDEFGHIJKLMNOPQRSTUVWXYZ'];
      const fragment = document.createDocumentFragment();

      orderedKeys.forEach((key) => {
        const groupItems = groups.get(key);
        if (!groupItems?.length) return;

        const group = document.createElement('section');
        const heading = document.createElement('h2');
        const label = document.createElement('span');
        const list = document.createElement('ul');
        const groupId = `BrandsListingGroup-${this.dataset.sectionId}-${key.toLowerCase()}`;

        group.className = 'brands-listing__group';
        group.id = groupId;
        group.dataset.brandGroup = key;
        group.setAttribute('aria-labelledby', `${groupId}-heading`);

        heading.className = 'brands-listing__group-heading';
        heading.id = `${groupId}-heading`;
        label.className = 'brands-listing__group-label';
        label.textContent = key;
        heading.append(label);

        list.className = 'brands-listing__grid';
        list.append(...groupItems);
        group.append(heading, list);
        fragment.append(group);
      });

      this.results.replaceChildren(fragment);
      this.setupFilters();
    }

    setupFilters() {
      this.filters?.addEventListener('click', this.handleFilterClick);
      this.filterBrands(this.dataset.activeFilter || 'all');
    }

    handleFilterClick(event) {
      const button = event.target.closest('[data-brand-filter]');
      if (!button || !this.filters?.contains(button)) return;

      this.filterBrands(button.dataset.brandFilter || 'all');
    }

    filterBrands(activeFilter) {
      this.dataset.activeFilter = activeFilter;

      this.querySelectorAll('[data-brand-group]').forEach((group) => {
        group.hidden = activeFilter !== 'all' && group.dataset.brandGroup !== activeFilter;
      });

      this.filters?.querySelectorAll('[data-brand-filter]').forEach((button) => {
        button.setAttribute('aria-pressed', String(button.dataset.brandFilter === activeFilter));
      });

      if (this.status) {
        this.status.textContent =
          activeFilter === 'all' ? 'Showing all brands.' : `Showing brands starting with ${activeFilter}.`;
      }
    }

    groupKey(name) {
      const normalizedName = name.trim().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
      const firstCharacter = normalizedName.charAt(0).toUpperCase();
      return /[A-Z]/.test(firstCharacter) ? firstCharacter : '0-9';
    }
  }

  if (!customElements.get('brands-listing')) {
    customElements.define('brands-listing', BrandsListing);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["japanese-contact-form"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-japanese-contact-success-close]').forEach((button) => {
    button.addEventListener('click', () => {
      const banner = button.closest('[data-japanese-contact-success]');
      if (!banner) return;
      banner.hidden = true;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
